import { FEATURE_GROUP } from '@/constants/features';

import useStoreSetting from '@/hooks/useStoreSetting';


// Reactive read of a backend-owned feature flag for the current store. Wraps `useStoreSetting`
// over the synthetic `features` group (TITAN-420). Returns false for an unknown / not-yet-loaded
// flag and for a null/empty key, so it is safe to call unconditionally (e.g. before an early return).
const useFeatureFlag = (key: string | null): boolean => {
	const { setting } = useStoreSetting(FEATURE_GROUP, key ?? '');
	return setting?.getEffectiveBooleanValue() ?? false;
};

export default useFeatureFlag;
